module.exports = __webpack_public_path__ + "static/img/pro1-1.5076b05.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro1-1.png
// module id = Mz4A
// module chunks = 0